import routerOptions0 from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}